import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./toast.scss";
import { IoMdClose } from "react-icons/io";

export interface ToastState {
    message: string;
    variant: "success" | "error";
}

interface ToastProps {
    message: string;
    onClose: () => void;
    variant?: "success" | "error";
    duration?: number;
}

const MAX_LENGTH = 120;

export default function Toast({ message, onClose, variant = "success", duration = 4000 }: ToastProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (variant === "error") return;
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [onClose, duration, variant]);

    const display = message.length > MAX_LENGTH ? message.slice(0, MAX_LENGTH) + "…" : message;

    return (
        <div
            className={`toast toast--${variant}`}
            role={variant === "error" ? "alert" : "status"}
            aria-live={variant === "error" ? "assertive" : "polite"}
        >
            <span className="toast__message">{display}</span>
            <button className="toast__close" onClick={onClose} aria-label={t("popup.close")}>
                <IoMdClose />
            </button>
        </div>
    );
}
